var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomeIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10 2.231c-.761 0-1.508.21-2.159.604L3.674 5.36a4.17 4.17 0 0 0-2.007 3.563v5.243a4.167 4.167 0 0 0 4.167 4.167h8.333a4.167 4.167 0 0 0 4.167-4.166V8.921a4.17 4.17 0 0 0-2.008-3.562L12.16 2.835A4.17 4.17 0 0 0 10 2.23M8.705 4.26a2.5 2.5 0 0 1 2.59 0l4.168 2.525a2.5 2.5 0 0 1 1.204 2.137v5.244a2.5 2.5 0 0 1-2.5 2.5h-.833v-2.5a3.333 3.333 0 0 0-6.667 0v2.5h-.833a2.5 2.5 0 0 1-2.5-2.5V8.923a2.5 2.5 0 0 1 1.204-2.138zm2.474 8.728c.312.313.488.737.488 1.178v2.5H8.334v-2.5a1.667 1.667 0 0 1 2.845-1.178",
  clipRule: "evenodd"
})));
export { SvgHomeIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/homeIcon.svg";